import { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Grid, Avatar, Typography, Menu, MenuItem , Button} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import PersonIcon from "@mui/icons-material/Person";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import {ChecklistRtlRounded} from '@mui/icons-material';
import SupportAgent from "@mui/icons-material/SupportAgent";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import settingsApi from "Services/Settings";
import ChatApp from "./Bell_icon";
import _ from "lodash";

//Redux
import { showSnackbar } from "../../Redux/SnackBar/actions";
import { setNewSiteLogo } from "../../Redux/SiteSettings/actions";

//
import { useDispatch } from "react-redux";

const Header = ({profileDetails}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authUser = useSelector(
    (state) => state?.AuthReducer?.user || {}
  );
  const userType = useSelector(
    (state) => state?.AuthReducer?.userType || ""
  );
  const triggerHeaderState = useSelector(
    (state) => state?.ProfileSettingsReducer?.triggerHeader
  );
  const siteNewL = useSelector(
    (state) => state?.SiteSettingsReducer?.siteNewLogo
  );

  // States
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate(0);
  };

  const handledispatcheropen = () => {
    navigate('/dispatcherpanel');
  };

  const handleopentriplist = () =>{
    navigate('/triplist');
  }

  const resolvedUser = {
    firstName:
      profileDetails?.firstName ||
      profileDetails?.first_name ||
      authUser?.firstName ||
      authUser?.first_name ||
      "",
    lastName:
      profileDetails?.lastName ||
      profileDetails?.last_name ||
      authUser?.lastName ||
      authUser?.last_name ||
      "",
    email: profileDetails?.email || authUser?.email || "",
    phone: profileDetails?.phone || authUser?.phone || "",
    avatar:
      profileDetails?.image ||
      profileDetails?.avatar_url ||
      authUser?.avatar_url ||
      "",
  };

  const displayName =
    (profileDetails?.user_name || profileDetails?.name ||
      `${resolvedUser.firstName} ${resolvedUser.lastName}`.trim() ||
      "Utilisateur");
  const displaySubtitle = resolvedUser.email || resolvedUser.phone || "Voir le profil";


  const getMasterValues = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        //console.log("settings fetched ", res?.data?.data);
        dispatch(
          setNewSiteLogo(res?.data?.data?.siteLogo)
        );
      } else {
        return;
      }
    };
    const onFailure = (err) => {
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    settingsApi.getMasterValues().then(onSuccess, onFailure);
  }, [dispatch]);

  useEffect(() => {
    getMasterValues();
  }, [ triggerHeaderState, siteNewL, getMasterValues]);

  return (
    <>
      <Grid container className={`${classes.root} ${classes.headernav} ${classes.welcomeContiner}`}>
        {/* Dispatcher panel */}   {/* Trip List */}
        <Grid item xs={6} className={classes.headerleftwrap} >

        <section className={classes.editIcon}>
              {/* Render when accountStatus is APPROVED */}
<Button variant="contained" color="success" className={classes.dispatcherbutton} startIcon={<SupportAgent />}
 onClick={() => handledispatcheropen()}
>
  Dispatcher panel
</Button>
        </section>

      {/* Hide trip list for usertype*/}
        {userType !== "SUB COMPANY" && (     
        <section className={classes.editIcon}>
              {/* Render when accountStatus is APPROVED */}
<Button variant="contained" color="success" className={classes.dispatcherbutton} startIcon={<ChecklistRtlRounded />}
 onClick={() => handleopentriplist()}
>
  Trip list
</Button>
        </section>
        )}
    
        </Grid>
       
        <Grid item  xs={6} className={classes.headerrightwrap}>

        {userType !== "SUB COMPANY" && ( <ChatApp /> )}

        <div
            className={classes.avatarContainer}
            id="menu"
            aria-controls={open ? "userMenu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <Avatar
              src={
                !_.isEmpty(resolvedUser.avatar)
                  ? `${resolvedUser.avatar}`
                  : "/assets/images/user/avatar.png"
              }
              alt={displayName}
              sx={{ width: 48, height: 48, cursor: "pointer" }}
            />
            <div className={classes.headerUserInfo}>
              <Typography variant="body1" className={classes.headerUserName}>
                {displayName}
              </Typography>
              <Typography variant="caption" className={classes.headerUserSub}>
                {displaySubtitle}
              </Typography>
            </div>
            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>

          <Menu
            id="userMenu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "menu",
            }}
            className={classes.menu}
            
          >
            <MenuItem
              onClick={() => {
                navigate("/profilesettings");
                handleClose();
              }}
              className={classes.menuItem}
            >
              <PersonIcon sx={{ fontSize: 20 }} />
              <Typography variant="body1" className={classes.menuLabels}>
                My Profile
              </Typography>
            </MenuItem>

{userType !== "SUB COMPANY" && ( 
  <MenuItem
              className={classes.menuItem}
              onClick={() => {
                navigate("/settings");
                handleClose();
              }}
            >
              <SettingsIcon sx={{ fontSize: 20 }} />
              <Typography variant="body1" className={classes.menuLabels}>
                Settings
              </Typography>
  </MenuItem>
)}

            <MenuItem
              onClick={() => {
                handleLogout();
                handleClose();
              }}
              className={classes.menuItem}
            >
              <LogoutIcon sx={{ fontSize: 20 }} />
              <Typography variant="body1" className={classes.menuLabels}>
                Logout
              </Typography>
            </MenuItem>
          </Menu>

        </Grid>
    
      </Grid>

    </>
  );
};

export default Header;
